/* eslint-disable no-shadow */
/* eslint-disable consistent-return */
import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/system';

/**
 *
 * @param {*} param0
 */
const Text = props => {
  const theme = useTheme();
  let {
    align,
    bold,
    avMedium,
    veryBold,
    light,
    color,
    customLinkStyle,
    customStyle,
    display,
    isSelected,
    isSelectedColor,
    large,
    link,
    id,
    testid,
    extraLarge,
    largest,
    margin,
    medium,
    mediumLarge,
    onClick,
    small,
    children,
    tiny,
    superTiny,
    uppercase,
    isDollar,
    formatted,
    tip
  } = props;

  /**
   * 
   */
  const setFontSize = () => {
    if (superTiny) {
      return '10px';
    }
    if (tiny) {
      return '12px';
    }
    if (small) {
      return '14px';
    }
    if (medium) {
      return '16px';
    }
    if (mediumLarge) {
      return '21px';
    }
    if (large) {
      return '24px';
    }
    if (extraLarge) {
      return '28px';
    }
    if (largest) {
      return '40px';
    }
    return '16px';
  };

  /**
   * 
   * @returns 
   */
  const setFontFamily = () => {
    if (light) {
      return '"AvenirLTPro-Light", sans-serif';
    }
    if (avMedium) {
      return '"AvenirLTPro-Medium", sans-serif';
    }
    if (bold || isSelected) {
      return '"AvenirLTPro-Heavy", sans-serif';
    }
    if (veryBold) {
      return '"AvenirLTPro-Heavy", sans-serif';
    }
    return '"AvenirLTPro-Book", sans-serif';
  };

  /**
   * \
   */
  const setColor = color => {
    switch (color) {
      case "inherit":
        return "inherit";
      case "primary":
        return theme.palette.primary.main;
      default:
        return color || theme.palette.default.contrastText;
    }
  };
  if (uppercase) {
    children = children.toUpperCase();
  }
  if (isSelected && isSelectedColor) {
    color = isSelectedColor;
  }
  if (typeof link !== 'string') {
    link = null;
  }
  if (isDollar) {
    children = Number(children).toFixed(2);
  }
  let textBlock = /*#__PURE__*/React.createElement("p", {
    id: id || testid,
    onClick: onClick && (() => onClick()),
    style: {
      fontSize: setFontSize(),
      fontFamily: setFontFamily(),
      fontWeight: veryBold ? 900 : "auto",
      letterSpacing: "0.14994px",
      textAlign: align || 'left',
      color: setColor(color),
      margin: margin || '0px 0px 0px 0px',
      display: display || 'block',
      ...customStyle
    }
  }, children);

  // if we want to keep the formatting, use a pre tag
  if (formatted) {
    textBlock = /*#__PURE__*/React.createElement("pre", {
      id: id || testid,
      onClick: onClick && (() => onClick()),
      style: {
        fontSize: setFontSize(),
        fontFamily: setFontFamily(),
        fontWeight: veryBold ? 900 : "auto",
        letterSpacing: "0.14994px",
        textAlign: align || 'left',
        color: setColor(color),
        margin: margin || '0px 0px 0px 0px',
        display: display || 'block',
        backgroundColor: 'transparent',
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        overflowWrap: 'anywhere',
        ...customStyle
      }
    }, children);
  }
  if (tip) {
    textBlock = /*#__PURE__*/React.createElement("span", {
      id: id || testid,
      onClick: onClick && (() => onClick()),
      style: {
        fontSize: setFontSize(),
        fontFamily: setFontFamily(),
        fontWeight: veryBold ? 900 : "auto",
        letterSpacing: "0.14994px",
        textAlign: align || 'left',
        color: setColor(color),
        margin: margin || '0px 0px 0px 0px',
        display: display || 'block',
        ...customStyle
      }
    }, children);
  }
  if (link) {
    return /*#__PURE__*/React.createElement(Link, {
      to: link,
      style: customLinkStyle ? customLinkStyle : {
        textDecoration: 'none'
      }
    }, textBlock);
  }
  return textBlock;
};
export default Text;